import { render, staticRenderFns } from "./top-navigation.vue?vue&type=template&id=57aa120f&scoped=true&"
import script from "./top-navigation.ts?vue&type=script&lang=ts&"
export * from "./top-navigation.ts?vue&type=script&lang=ts&"
import style0 from "./top-navigation.scss?vue&type=style&index=0&id=57aa120f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57aa120f",
  null
  
)

component.options.__file = "top-navigation.vue"
export default component.exports